import Vue from 'vue';

export default () => {
  Vue.filter('formatFiatAmount', function (fiatAmount: number) {
    return `${fiatAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  });
};
